import React from 'react';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { shouldAutoOpenLoginModal } from '../utils/modalUtils';

export const MMTHeader = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const [importedComponent, setImportedComponent] = useState(null);
  const [autoOpenLoginModal, setAutoOpenLoginModal] = useState(false);

  useEffect(() => {
    const checkAutoOpenStatus = () => {
      if (!isMobileDevice) {
        const currentAutoOpenStatus = shouldAutoOpenLoginModal();
        setAutoOpenLoginModal(currentAutoOpenStatus);
      }
    };

    // Add 2 second delay before checking auto open status
    const timer = setTimeout(() => {
      checkAutoOpenStatus();
    }, 1000);

    return () => clearTimeout(timer);
  }, [isMobileDevice]);

  useEffect(() => {
    // Only proceed if we're on desktop
    if (!isMobileDevice) {
      const importComponent = async () => {
        const module = await import('pwa-mmt-ui-header/ssr/header');
        const MMTHeaderComponent = module.Header;

        setImportedComponent(
          <MMTHeaderComponent
            selectedTabName={'Cabs'}
            autoOpenLoginModal={autoOpenLoginModal}
          />
        );
      };

      const timer = setTimeout(() => {
        importComponent();
      }, 1500);

      return () => clearTimeout(timer);
    } else {
      // Mobile: Ensure no header component is set and clear any existing component
      setImportedComponent(null);
    }
  }, [autoOpenLoginModal, isMobileDevice]);

  return <>{importedComponent}</>;
};
